import * as ActionTypes from '../ActionTypes';


// ECMS Exit Reason Actions
export const GetECMSExitReasonAction = (params) => {
    return {
        type: ActionTypes.GET_ECMS_EXIT_REASON_REQUEST,
        params,
    };
};

export const AddECMSExitReasonAction = (params) => {
    return {
        type: ActionTypes.ADD_ECMS_EXIT_REASON_REQUEST,
        params,
    };
};

export const UpdateECMSExitReasonAction = (params) => {
    return {
        type: ActionTypes.UPDATE_ECMS_EXIT_REASON_REQUEST,
        params,
    };
};

export const DeleteECMSExitReasonAction = (params) => {
    return {
        type: ActionTypes.DELETE_ECMS_EXIT_REASON_REQUEST,
        params,
    };
};

// ECMS Clearance type and approver
export const GetECMSClearanceTypeAction = (params) => ({
    type: ActionTypes.GET_ECMS_CLEARANCE_TYPE_REQUEST,
    params,
});

export const AddECMSClearanceTypeAction = (params) => ({
    type: ActionTypes.ADD_ECMS_CLEARANCE_TYPE_REQUEST,
    params,
});

export const UpdateECMSClearanceTypeAction = (params) => ({
    type: ActionTypes.UPDATE_ECMS_CLEARANCE_TYPE_REQUEST,
    params,
});

export const DeleteECMSClearanceTypeAction = (params) => ({
    type: ActionTypes.DELETE_ECMS_CLEARANCE_TYPE_REQUEST,
    params,
});
